export const onlyDigits = (value = '') => `${value}`.replace(/\D/g, '');

export const isCPF = value => {
  const cpf = onlyDigits(value);

  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  const digit = length => {
    let sum = 0;
    for (let i = 0; i < length; i++) {
      sum += Number(cpf[i]) * (length + 1 - i);
    }
    const rest = (sum * 10) % 11;
    return rest === 10 || rest === 11 ? 0 : rest;
  };

  return digit(9) === Number(cpf[9]) && digit(10) === Number(cpf[10]);
};

export const isCNPJ = value => {
  const cnpj = onlyDigits(value);

  if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

  const digit = weights => {
    const sum = weights.reduce(
      (acc, weight, i) => acc + Number(cnpj[i]) * weight,
      0
    );
    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
  };

  const first = digit([5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  const second = digit([6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

  return first === Number(cnpj[12]) && second === Number(cnpj[13]);
};

export const isCEP = value => /^\d{8}$/.test(onlyDigits(value));

const documents = {
  onlyDigits,
  isCPF,
  isCNPJ,
  isCEP
};

export default documents;
